module.exports = __webpack_public_path__ + "AvenirNextCondensed-HeavyItalic.ttf";